import React, { Component } from 'react';
import { connect } from "react-redux";
import axios from "axios";
import moment from "moment";
import Select from 'react-select';
import { Trans } from 'react-i18next';

import { constants } from '../../../Helpers/Constants';
import { receiveTime, reverseReceiveTime } from '../../../Helpers/ReceiveTimeInArray';
import { setBookingsDb } from '../../../Actions/dataActions';
import { openPullout } from '../../../Actions/stakeholderActions';

import VehicleCell from "../../Pages/Stakeholder/Vehicle/VehicleCell";
import ProfileCell from "../../Pages/Stakeholder/User/ProfileCell";
import DatePicker from '../DatePicker.jsx';
import LabelledOutline from '../LabelledOutline';
import Badge from '../Badge';
import { EditBookingActionButtons, parseBookingFormInput } from './EditBookingActionButtons';
import Button from '../DesignSystem/Button';
import colours from '../DesignSystem/Colours';
import { getTimeZoneAbbreviation } from '../../../Helpers/getTimeZoneAbbreviation';

class EditBookingPullout extends Component {
    constructor(props) {
        super(props);

        this.submitEdit = this.submitEdit.bind(this);
        this.selectTime = this.selectTime.bind(this);
        this.selectUsage = this.selectUsage.bind(this);
        this.updateForm = this.updateForm.bind(this);
        this.selectStartDate = this.selectStartDate.bind(this);
        this.selectEndDate = this.selectEndDate.bind(this);
        this.renderUser = this.renderUser.bind(this);
        this.closeEdit = this.closeEdit.bind(this);
        this.getUseLocaleTime = this.getUseLocaleTime.bind(this);

        this.state = {
            booking_form: {
                start_date: this.props.booking.Start_Date,
                end_date: this.props.booking.End_Date
            },
            pickup_times: [],
            dropoff_times: [],
            start_date: this.props.booking.Start_Date,
            end_date: this.props.booking.End_Date,
            tempLocaleTime: {}
        };
    }

    componentDidMount() {
        var self = this;
        var unavailable_dates = {}

        this.loadPickupTimes(this.props.booking.Start_Date);
        this.loadDropoffTimes(this.props.booking.End_Date);

        var booking_form = {}
        booking_form['vehicle_id'] = this.props.booking.V_ID
        booking_form['start_date'] = this.props.booking.Start_Date
        booking_form['end_date'] = this.props.booking.End_Date
        booking_form['pick_up_time'] = receiveTime(moment(this.props.booking.Release_Time, "HH:mm:ss").format("h:mmA"))
        booking_form['drop_off_time'] = receiveTime(moment(this.props.booking.Return_Time, "HH:mm:ss").format("h:mmA"))
        booking_form['pick_up_location'] = this.props.booking.Release_Address
        booking_form['drop_off_location'] = this.props.booking.Return_Address
        booking_form['booking_type'] = this.props.booking.Book_Type
        booking_form['user'] = this.props.booking.Profile_ID
        booking_form['vehicle_usage'] = this.props.booking.Usage_Type
        booking_form['service_usage'] = this.props.booking.Vehicle_Usage
        booking_form['pick_up_person'] = this.props.booking.Release_To
        booking_form['notes'] = this.props.booking.Special_Requests
        if (this.props.highlightEvent)
            this.props.highlightEvent(this.props.booking?.event);

        this.setState({
            edit: !this.state.edit,
            booking_form: booking_form,
            tempLocaleTime: this.getUseLocaleTime()
        })
    }

    componentDidUpdate(prevProps) {
        if (prevProps && prevProps.booking !== this.props.booking) {
            prevProps.highlightEvent(prevProps.booking?.event, false);
            if (this.props.highlightEvent)
                this.props.highlightEvent(this.props.booking?.event, true);
        }
    }

    componentWillUnmount() {
        this.setState({ edit: false });
        this.props.endEdit();
        if (this.props.highlightEvent)
            this.props.highlightEvent(this.props.booking?.event, false);
    }

    getUseLocaleTime = () => {
        const scheduledReleasedAt = moment(this.props?.stakeholder?.current_booking?.extendedProps?.booking?.scheduledReleasedAt).format('YYYY-MM-DDTHH:mm:ssZ')
        const scheduledReturnedAt = moment(this.props?.stakeholder?.current_booking?.extendedProps?.booking?.scheduledReturnedAt).format('YYYY-MM-DDTHH:mm:ssZ')

        return {
            scheduledReleasedAt,
            releaseTime: moment(scheduledReleasedAt).format("h:mm a"),
            releaseDate: moment(scheduledReleasedAt).format("MMM D, YYYY"),
            scheduledReturnedAt,
            returnTime: moment(scheduledReturnedAt).format("h:mm a"),
            returnDate: moment(scheduledReturnedAt).format("MMM D, YYYY"),
        }
    }

    closeEdit() {
        this.setState({ edit: false });
        this.props.closePullout();
    }

    submitEdit(updateBookingGraphQL, setLoadingUpdate) {
        var self = this;

        const temp_booking_submission = this.state.booking_form;

        if ((this.props.booking.Prep_Status == constants.prep_status.out && this.props.booking.Released_On != null) ? true : false) {
            temp_booking_submission['booking_start_date'] = undefined;
        }

        axios.post('/ajax/booking/' + this.props.booking.BOOK_ID + "/update", temp_booking_submission)
            .then(function (response) {
                //Update the booking
                var booking_db = self.props.data.bookings_db
                if (self.props.booking.BOOK_ID in booking_db) {
                    booking_db[self.props.booking.BOOK_ID]['Start_Date'] = self.state.booking_form['start_date']
                    booking_db[self.props.booking.BOOK_ID]['End_Date'] = self.state.booking_form['end_date']
                    booking_db[self.props.booking.BOOK_ID]['Release_Time'] = moment(reverseReceiveTime(self.state.booking_form['pick_up_time'] - 1), "h:mmA").format("HH:mm:ss")
                    booking_db[self.props.booking.BOOK_ID]['Return_Time'] = moment(reverseReceiveTime(self.state.booking_form['drop_off_time'] - 1), "h:mmA").format("HH:mm:ss")
                    booking_db[self.props.booking.BOOK_ID]['Usage_Type'] = self.state.booking_form['vehicle_usage']
                    booking_db[self.props.booking.BOOK_ID]['Special_Requests'] = self.state.booking_form['notes']
                }

                self.props.dispatch(setBookingsDb([], booking_db));

                var current_booking = self.props.stakeholder.current_booking
                current_booking['Start_Date'] = self.state.booking_form['start_date']
                current_booking['End_Date'] = self.state.booking_form['end_date']
                current_booking['Release_Time'] = moment(reverseReceiveTime(self.state.booking_form['pick_up_time']), "h:mmA").format("HH:mm:ss")
                current_booking['Return_Time'] = moment(reverseReceiveTime(self.state.booking_form['drop_off_time']), "h:mmA").format("HH:mm:ss")
                current_booking['Usage_Type'] = self.state.booking_form['vehicle_usage']
                current_booking['Special_Requests'] = self.state.booking_form['notes']

                // self.props.dispatch(openPullout(current_booking))
                // if (self.props.stakeholder.current_booking && self.props.stakeholder.current_booking.loadData)
                // self.props.stakeholder.current_booking.loadData();
                const tempLocaleTime = { ...self.state.tempLocaleTime }
                const currentBooking = { ...self.props.booking, ...current_booking, tempLocaleTime };

                // [not in use due to queue data sync implementation]
                // updateBookingGraphQL(temp_booking_submission, currentBooking, self.closeEdit);

                if (self.props.booking && self.props.booking.onEdit) {
                    self.props.booking.onEdit(self.props.booking);
                } else {
                    // [this logic is here due to queue data sync implementation]
                    const { calendarRef, event, ...booking } = currentBooking;
                    const parsedBookingInput = parseBookingFormInput(temp_booking_submission, currentBooking); // to get scheduledReleasedAt and scheduledReturnedAt times before refreshing the page
                    const parsedBooking = {
                        ...booking,
                        extendedProps: {
                            ...booking.extendedProps,
                            booking: {
                                ...booking.extendedProps.booking,
                                ...parsedBookingInput,
                            }
                        }
                    }
                    localStorage.setItem('currentBooking', JSON.stringify(parsedBooking));
                    window.location.reload();
                }
            })
            .catch(function (error) {
                console.log('error :>> ', error);
                setLoadingUpdate(false);

                if (error.response?.status == 401) {
                    showStatusMsg(error.response?.data.error);
                } else if (error.response?.status == 422) {
                    var error_message = "";

                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });

                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }
            })
    }

    selectStartDate(event) {
        let booking_form = this.state.booking_form

        booking_form['start_date'] = moment(event.target.value).format("YYYY-MM-DD");
        booking_form['pick_up_time'] = null

        this.setState({
            booking_form: booking_form,
            start_date: event.target.value,
            tempLocaleTime: {
                ...this.state.tempLocaleTime,
                releaseDate: undefined
            }
        })

        this.loadPickupTimes(event.target.value)
    }

    selectEndDate(event) {
        let booking_form = this.state.booking_form

        booking_form['end_date'] = moment(event.target.value).format("YYYY-MM-DD");
        booking_form['drop_off_time'] = null

        this.setState({
            booking_form: booking_form,
            end_date: event.target.value,
            tempLocaleTime: {
                ...this.state.tempLocaleTime,
                returnDate: undefined
            }
        })

        this.loadDropoffTimes(event.target.value);
    }

    loadPickupTimes(date) {
        var self = this;

        axios.post('/ajax/vehicle/' + this.props.booking.V_ID + "/options", {
            'date': date,
            'type': 'pickup',
            'booking_id': this.props.booking.BOOK_ID
        })
            .then(function (response) {
                self.setState({
                    pickup_times: response?.data
                })
            })
    }

    loadDropoffTimes(date) {
        var self = this;
        axios.post('/ajax/vehicle/' + this.props.booking.V_ID + "/options", {
            'date': date,
            'type': 'dropoff',
            'booking_id': this.props.booking.BOOK_ID
        })
            .then(function (response) {
                self.setState({
                    dropoff_times: response?.data
                })
            })
    }

    selectTime(event, type) {
        let booking_form = this.state.booking_form
        let tempLocaleTime = { ...this.state.tempLocaleTime };
        if (type === "pickup") {
            booking_form["pick_up_time"] = event.value
            delete tempLocaleTime.releaseTime
        } else if (type === "dropoff") {
            booking_form["drop_off_time"] = event.value
            delete tempLocaleTime.returnTime
        }

        this.setState({
            booking_form: booking_form,
            tempLocaleTime
        })
    }

    selectUsage(event) {
        let booking_form = this.state.booking_form
        booking_form["vehicle_usage"] = event.value

        this.setState({
            booking_form: booking_form
        })
    }

    updateForm(event) {
        let value = event.target.value
        let name = event.target.name
        let booking_form = this.state.booking_form

        booking_form[name] = event.target.value

        this.setState({
            booking_form: booking_form
        })
    }

    renderUser(profile) {
        if (this.props.booking.Book_Type == constants.booking_type.service) {
            profile.Book_Type = constants.booking_type.service;
        }
        return (
            <LabelledOutline label="User" id="user">
                <div style={{ display: 'flex', flex: 1 }}>
                    <ProfileCell profile={profile} showImage showContact={this.props.booking.Book_Type != constants.booking_type.service} />
                </div>
            </LabelledOutline>
        )
    }

    render() {
        return (
            <div className="booking_pullout new_booking_pullout">
                <div className="booking_header border-bottom">
                    <div className="card-header-title no-margin float-left" style={{ display: 'flex', flexDirection: 'row' }}>
                        <Trans>Edit Booking</Trans>
                        <div style={{ marginLeft: 10, verticalAlign: 'top', paddingTop: 0, paddingBottom: 0 }}>
                            <Badge status={this.props.booking.Book_Status} service={this.props.booking.Book_Type == 2} completed={this.props.booking.Returned_On !== null} />
                        </div>
                    </div>
                    <button onClick={this.props.closePullout} type='button' style={{ cursor: "pointer" }} className="float-right">
                        <span aria-hidden='true' style={{ fontSize: "1.8em", lineHeight: 1, display: "block" }}>&times;</span>
                    </button>
                    <div className="clearfix"></div>
                </div>
                <div className="card-section">
                    <div className="row mb-24">
                        <VehicleCell history={this.props.history} match={this.props.match} location={this.props.location} vehicle={this.props.data.vehicle_db[this.props.booking.V_ID]} noOverlay showType noTooltip />
                        <div className="new_booking_pullout_vehicle-image-container">
                            {!this.state.loading && (this.props.booking.resource?._resource?.extendedProps?.vehicle?.photoUrl || this.props.booking.extendedProps?.vehicle?.photoUrl) ? (
                                <img
                                    style={{ borderRadius: '15px', height: this.state.loading ? '180px' : undefined }}
                                    src={this.props.booking.resource?._resource?.extendedProps?.vehicle?.photoUrl || this.props.booking.extendedProps?.vehicle?.photoUrl}
                                />
                            ) : (
                                <img
                                    style={{ borderRadius: '15px' }}
                                    src={this.props?.booking?.vehicle && this.props.booking.vehicle.Photos ?
                                        'https://digitalvms.s3.ca-central-1.amazonaws.com/vehicle-images/' + this.props.booking.vehicle.Photos
                                        : this.props?.data?.vehicle_db[this.props.booking.V_ID]?.Photos ?
                                            'https://digitalvms.s3.ca-central-1.amazonaws.com/vehicle-images/' + this.props.data.vehicle_db[this.props.booking.V_ID].Photos
                                            : this.props.settings.images.vehicle_placeholder_square.includes("images/") ?
                                                this.props.settings.images.vehicle_placeholder_square
                                                : "images/" + this.props.settings.images.vehicle_placeholder_square}
                                />
                            )}
                        </div>
                    </div>
                    {this.props.booking.profile ? <div className="mb-12">
                        {this.renderUser(this.props.booking.profile)}
                    </div> : null}
                    <div className="row mb-8">
                        {
                            this.props.booking.Book_Type === constants.booking_type.service ?
                                <label><Trans>Service Type</Trans>
                                    <input type="text" name="service_usage" placeholder="Service Usage" defaultValue={this.props.booking.Vehicle_Usage} onChange={this.updateForm} />
                                </label>
                                :
                                <label><Trans>Vehicle Usage</Trans>
                                    <Select
                                        className="react_select_dropdown"
                                        classNamePrefix="react_select"
                                        defaultValue={{ value: this.props.booking.Usage_Type, label: this.props.settings.vehicle_usage_types[this.props.booking.Usage_Type] }}
                                        onChange={this.selectUsage}
                                        options={
                                            Object.keys(this.props.settings.vehicle_usage_types).map((key) => {
                                                return (
                                                    { value: key, label: this.props.settings.vehicle_usage_types[key] }
                                                )
                                            })
                                        } />
                                </label>
                        }
                    </div>
                    {/* <h4 className="mb-8"><Trans>Dates & Times</Trans></h4> */}
                    <div className="datesandtimes">
                        <div className="pickup">
                            {/* <div className = "datetime-field"> */}
                            <div className="body medium"><Trans>Pick Up</Trans></div>
                            <DatePicker id="edit-start-date" className="date-input-field datetime-date date-field datepicker-start no-weekends mb-5"
                                name="booking_start_date" placeholder="Select Date ..." disabled={(this.props.booking.Prep_Status == constants.prep_status.out && this.props.booking.Released_On != null) ? true : false} booking_id={this.props.booking.BOOK_ID}
                                value={
                                    this.state.tempLocaleTime.releaseDate ? this.state.tempLocaleTime.releaseDate
                                        : this.state.start_date ? moment(this.state.start_date).format("MMM DD, YYYY")
                                            : ""
                                }
                                updateValue={this.selectStartDate}
                            />
                            <div className="datetime-time select-eu-vehicle">
                                <Select
                                    className="react_select_dropdown react_select_dropdown--hide-selected time-select"
                                    classNamePrefix="react_select"
                                    onChange={(e) => this.selectTime(e, "pickup")}
                                    value={{ value: this.state.booking_form.pick_up_time, label: this.state.tempLocaleTime.releaseTime && this.state.booking_form.pick_up_time ? this.state.tempLocaleTime.releaseTime : this.state.booking_form.pick_up_time ? reverseReceiveTime(this.state.booking_form.pick_up_time) : '' }}
                                    options={
                                        this.state.pickup_times?.map((time) => {
                                            return (
                                                { value: time.value, label: time.option }
                                            )
                                        })
                                    }
                                    isDisabled={(this.props.booking.Prep_Status == constants.prep_status.out && this.props.booking.Released_On != null) ? true : false}
                                />
                            </div>
                            {
                                this.props.booking.Prep_Status == constants.prep_status.out && this.props.booking.Released_On != null ?
                                    <>
                                        <input type="hidden" name="booking_start_date" value={this.state.tempLocaleTime.releaseDate ? this.state.tempLocaleTime.releaseDate : this.state.start_date ? moment(this.state.start_date).format("MMM DD, YYYY") : ""} />
                                        <input type="hidden" name="pick_up_time" value={this.state.tempLocaleTime.returnDate ? this.state.tempLocaleTime.returnDate : this.state.booking_form.pick_up_time} />
                                    </>
                                    :
                                    null
                            }
                            <div className="clearfix"></div>
                            {/* </div> */}
                        </div>
                        <div className="arrow">
                            <i className="fas fa-arrow-right overlay_section_details_date_arrow" style={{ fontSize: '32px', color: 'lightgrey', marginTop: 45 }}></i>
                        </div>
                        <div className="dropoff">
                            <div className="body medium"><Trans>Drop Off</Trans></div>
                            <DatePicker key={"datepicker-dropoff-" + this.state.start_date} id="edit-end-date" className="date-input-field datetime-date date-field datepicker-start no-weekends mb-5"
                                name="booking_end_date" placeholder="Select Date ..." disabled={false} booking_id={this.props.booking.BOOK_ID}
                                value={this.state.tempLocaleTime.returnDate ? this.state.tempLocaleTime.returnDate : this.state.end_date ? moment(this.state.end_date).format("MMM DD, YYYY") : ""} updateValue={this.selectEndDate} start_date_id="edit-start-date" />
                            <div className="datetime-time select-eu-vehicle">
                                <Select
                                    className="react_select_dropdown react_select_dropdown--hide-selected time-select"
                                    classNamePrefix="react_select"
                                    onChange={(e) => this.selectTime(e, "dropoff")}
                                    value={{ value: this.state.booking_form.drop_off_time, label: this.state.tempLocaleTime.returnTime && this.state.booking_form.drop_off_time ? this.state.tempLocaleTime.returnTime : this.state.booking_form.drop_off_time ? reverseReceiveTime(this.state.booking_form.drop_off_time) : '' }}
                                    options={
                                        this.state.dropoff_times?.map((time) => {
                                            return (
                                                { value: time.value, label: time.option }
                                            )
                                        })
                                    } />
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>

                    <div className="mb-24">
                        <Button
                            secondary
                            leading_ic="Clock"
                            label={`Timezone: ${getTimeZoneAbbreviation(this.props.booking.vmh.Display_City)} – ${this.props.booking.vmh.Display_City}`}
                            style={{ color: colours.primary.grey01 }}
                        />
                    </div>

                    <div className="row collapse">
                        {/* <h4 className="mb-8"><Trans>Booking Information</Trans></h4> */}
                        <div className="columns large-12 medium-12 small-12 ">
                            <label><Trans>Booking Notes</Trans>
                                <textarea name="notes" defaultValue={this.props.booking.Special_Requests} onChange={this.updateForm} />
                            </label>
                        </div>
                    </div>
                </div>

                <EditBookingActionButtons
                    endEdit={this.props.endEdit}
                    submitEdit={this.submitEdit}
                    booking={this.props.booking}
                    settings={this.props.settings}
                    stakeholder={this.props.stakeholder}
                />
            </div>
        )
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    data: store.data,
    settings: store.settings,
    stakeholder: store.stakeholder
});

export default connect(mapStateToProps)(EditBookingPullout);